import { makeStyles } from "@mui/styles";
import color from "@definitions/mui/color";
import useResponsive from "@helpers/useResponsive";

const useStyles = () => {
  const isMD = useResponsive("md");
  return makeStyles(() => ({
    drawerSelected: {
      color: color.primary.main,
      border: `1px solid ${color.grey.light}`,
      padding: 16,
      borderRadius: 8,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      gap: 16,
    },
    drawer: {
      borderRadius: "20px 20px 0px 0px",
      padding: isMD ? "11px 16px 16px 16px" : "8px 16px 30px 16px",
    },
    puller: {
      width: 50,
      height: 3,
      backgroundColor: color.general.light,
      borderRadius: 3,
      marginBottom: 12,
      marginTop: 8,
    },
    categoryItem: {
      "&:not(:last-child)": {
        borderBottom: `1px solid ${color.grey.light}`,
      },
      padding: "16px 0",
      cursor: "pointer",
    },
    titleWrapper: {
      borderBottom: `1px solid ${color.grey.light}`,
    },
  }))();
};

export default useStyles;